import { useDispatch, useSelector} from "react-redux"

import Filters from "./filters/filters"
import TableView from "./atoms/TableView"
import { useEffect, useState } from "react"
import { loadTenantAnalytics, loadTenants } from "../interfaces/tenantInterface"
import { checkEqual } from "../helpers/helper"
import { clearTenantsInfo } from "../features/rentSlice"
import PersistantRef from "./atoms/PersistantRef"
import { Tag , Row , Col, Button, message } from "antd"
import { FormNavigator } from "../dynamicform/formNavigator"
import apiAction from "../ajax/service"
import { useNavigate } from "react-router-dom"
import DynamicDashboard from "./analytics/DynamicDashboard"
import CenteredDisplay from "./atoms/CenteredContent"
const TenantView = () =>{
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [selectedIds , setSelectedIds] = useState([])
    const tenants = useSelector(state=>state.rent.tenants)
    const currentPage = useSelector(state=>state.rent.tenants.currentPage)
    const shouldShowAnalytics = useSelector((state)=>state.workspace?.role?.sensitiveInfoBlock?.analytics || false)
    const tenantFilters = useSelector(state=>state.rent.tenantFilters)
      const previousTenantFilters = new PersistantRef(
    "previousTenantFilters"
  );
  const allTenantsInfo = useSelector(state=>state.analytics.alltenant)
  const formNavigator = FormNavigator(dispatch)
    useEffect(()=>{
        if (!checkEqual(tenantFilters, previousTenantFilters.getValue())) {
      dispatch(clearTenantsInfo());
      loadTenants(dispatch,undefined,undefined,new Set(Object.keys(tenants)),tenantFilters)
      previousTenantFilters.setValue(tenantFilters);
    }

    },[tenantFilters])
    const handleBulkAction = (type) =>{

         var i = 0
                    for (var tenantId of selectedIds){
                        apiAction("forms",{modal:"tenant",archived:type == "archive",id:tenantId},"update").then(()=>{
                            message.success( type+" Tenant " + tenantId)
                            if (i == selectedIds.length){
                                dispatch(clearTenantsInfo())
                                loadTenants(dispatch,undefined,undefined,new Set(Object.keys(tenants)),tenantFilters)
                                setSelectedIds([])
                            }
                        })
                    i+=1
                    }
    }
    useEffect(()=>{
        loadTenants(dispatch,undefined,undefined,new Set(Object.keys(tenants)),tenantFilters)
        if(shouldShowAnalytics){
            loadTenantAnalytics(dispatch)
        }

    },[shouldShowAnalytics])

    return (

        <>
        { !tenants.totalData && <CenteredDisplay timeout={7000} isLoading={!tenants && !tenants[currentPage]  && !tenants[currentPage]?.length} title={"No Tenants Created Yet"} description={"Create a Tenants to Get Started"}  actionText={"Add"} actionCallback={()=>formNavigator.lead(-1)}/>}
        {tenants.totalData > 0 &&
        <>
        <Row>
            { allTenantsInfo.data &&
        <DynamicDashboard dataSource={allTenantsInfo.data} dashboard={"alltenant"}  />}
            <Col span={16}><Filters dispatch={dispatch} filterPage="tenants" values={tenantFilters} /></Col>
            <Col span={8} className="m-auto">

                <Button variant="solid" disabled={selectedIds.length == 0} color="red" style={{margin :'auto',float:'right'}}
                onClick={()=>{
                   handleBulkAction('archive')

                }}
                > Archive </Button>
                <Button variant="solid" disabled={selectedIds.length == 0} color="green" style={{margin :'auto',float:'right',right:5}}
                onClick={()=>{
                   handleBulkAction('activate')

                }}
                > Activate </Button>
                <Button  style={{margin :'auto',float:'right',right:10}}
                onClick={()=>{
                   formNavigator.tenant(-1)

                }}
                > Create </Button>

            </Col>
        </Row>


        <TableView
        editableCallback = {( {id})=>{
                formNavigator.tenant(id)
              }}
        rowKey={'id'}
        totalData={tenants.totalData}
        pageLimit={25}
        data={tenants[currentPage]}
        onlyFields={["name","email","phone","archived"]}
        onPageChange={(pageNum)=>{
            loadTenants(dispatch,pageNum,25,new Set(Object.keys(tenants)),tenantFilters)
        }}

        rowSelection={{
            selectedRowKeys:selectedIds,
            onChange : setSelectedIds
        }}
        renderFunctions={{
            archived:(value)=>value?<Tag color="red">inactive</Tag>:<Tag color="green">active</Tag>
        }}
        expandable={{expandedRowRender:(record)=>`Address : ${record.address}`}}
        /></>}
        </>
    )

}

export default TenantView
